import { useMemo } from "react"

import { useWindowSize } from "src/hooks/use_window_size"

export const useResponsiveView = (columns) => {
  const { isXLScreen } = useWindowSize()

  const hasCardRoles = useMemo(
    () => columns.some((col) => col.cardRole),
    [columns]
  )

  const shouldShowCards = !isXLScreen && hasCardRoles

  return { shouldShowCards }
}
